


































import { Modal as modalWindow } from '@/components/modal';
import ExtLink from '@/components/ext/Link.vue';
import Button from '@/components/ext/Button.vue';

export default {
  name: 'PersonalDataConsentModal',
  components: {
    modalWindow,
    ExtLink,
    Button,
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/personalDataConsentModal/PersonalDataConsentModal.vue